import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { IPublication, IStory } from '@opengov/stories-shared/types';

import { IModalMessages } from '../../../types';
import { PublishStoryInput } from '../../../stories/components/StoryView/hooks/useStoryMutations';

import { styles } from './RepublishStory.styles';

export type IRepublishStoryProps = {
  open: boolean;
  onClose(): void;
  story: IStory;
  publication?: IPublication;
  userId: number;
  isAdmin: boolean;
  hasGallery: boolean;
  isTemplate: boolean;
  entitySubdomain: string;
  isInternal: boolean;
  storiesAccessControlEnabled?: boolean;
  currentSubjectPublicationStoryClaim?: any;
  messages: IModalMessages;
  publishStory(props: PublishStoryInput): void;
  updatePublicationUpdatedAt(props: { publicationId: string; userId: number }): Promise<void>;
}

export const RepublishStory: React.FC<IRepublishStoryProps> = ({
  open,
  onClose,
  story,
  publication,
  userId,
  isAdmin,
  hasGallery,
  isTemplate,
  entitySubdomain,
  isInternal,
  storiesAccessControlEnabled,
  currentSubjectPublicationStoryClaim,
  messages,
  publishStory,
  updatePublicationUpdatedAt,
}) => {
  if (!open) return null;

  const handleSubmit = () => {
    if (publication?.id && userId) {
      void updatePublicationUpdatedAt({ publicationId: publication.id, userId });
    }
    onClose();
    publishStory({
      isTemplate,
      isAdmin,
      hasGallery,
      entitySubdomain,
      story,
      userId,
      isInternal,
      storiesAccessControlEnabled,
      currentSubjectPublicationStoryClaim,
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{ sx: styles.dialogPaper }} aria-labelledby="republish-story-dialog-title">
      <DialogTitle id="republish-story-dialog-title" sx={styles.dialogTitle}>
        {messages.republishStory}
        <IconButton aria-label="close" onClick={onClose} size="small" sx={styles.closeButton}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Typography variant="body2">{messages.updateExistingStoryText}</Typography>
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button variant="outlined" color="secondary" size="small" onClick={onClose} data-test="story-republish-cancel">
          {messages.cancel}
        </Button>
        <Button variant="contained" color="primary" size="small" onClick={handleSubmit} data-test="story-republish-confirm">
          {messages.republish}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
